export function Privacidad() {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto max-w-4xl px-6">
        <h1 className="text-4xl font-bold text-gray-900 mb-8">Política de Privacidad</h1>
        
        <div className="space-y-6 text-gray-700 leading-relaxed">
          <p>
            <strong>Última actualización:</strong> {new Date().toLocaleDateString('es-ES')}
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">1. Responsable del tratamiento</h2>
          <p>
            Ricardo Fernández Gómez<br />
            Email: rfgmusicaespacio@gmail.com<br />
            Teléfono: +34 616 077 104
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">2. Datos que recopilamos</h2>
          <p>
            A través del formulario de contacto, recopilamos:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Nombre</li>
            <li>Dirección de correo electrónico</li>
            <li>Mensaje/consulta</li>
          </ul>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">3. Finalidad del tratamiento</h2>
          <p>
            Los datos proporcionados se utilizarán exclusivamente para:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Responder a consultas sobre clases de guitarra</li>
            <li>Proporcionar información sobre servicios musicales</li>
            <li>Gestionar solicitudes de contacto</li>
          </ul>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">4. Base legal</h2>
          <p>
            El tratamiento de sus datos se basa en el consentimiento expreso que otorga al marcar 
            la casilla del formulario de contacto.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">5. Conservación de datos</h2>
          <p>
            Sus datos se conservarán únicamente durante el tiempo necesario para responder a su 
            consulta o solicitud, y posteriormente serán eliminados, salvo que exista obligación 
            legal de conservarlos.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">6. Destinatarios</h2>
          <p>
            Sus datos no serán cedidos a terceros, salvo obligación legal. El envío de emails 
            se realiza a través del servicio EmailJS, que actúa como encargado del tratamiento.
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">7. Derechos del usuario</h2>
          <p>
            Puede ejercer los siguientes derechos:
          </p>
          <ul className="list-disc pl-6 space-y-2">
            <li>Derecho de acceso a sus datos personales</li>
            <li>Derecho de rectificación de datos inexactos</li>
            <li>Derecho de supresión cuando los datos ya no sean necesarios</li>
            <li>Derecho de oposición al tratamiento</li>
            <li>Derecho de portabilidad de los datos</li>
            <li>Derecho a retirar el consentimiento en cualquier momento</li>
          </ul>
          <p className="mt-4">
            Para ejercer estos derechos, puede contactar en: <strong>rfgmusicaespacio@gmail.com</strong>
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">8. Reclamaciones</h2>
          <p>
            Si considera que el tratamiento de sus datos no se ajusta a la normativa, puede 
            presentar una reclamación ante la Agencia Española de Protección de Datos (
            <a href="https://www.aepd.es" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
              www.aepd.es
            </a>
            ).
          </p>

          <h2 className="text-2xl font-semibold text-gray-900 mt-8 mb-4">9. Seguridad</h2>
          <p>
            Adoptamos las medidas técnicas y organizativas necesarias para garantizar la 
            seguridad de sus datos y evitar su alteración, pérdida, tratamiento o acceso no autorizado.
          </p>
        </div>
      </div>
    </section>
  );
}
